<template>
  <div style="height:40px;color: white;font-size: 14px;padding-left: 80px">
    <v-btn @click="changePageNumber(parseInt(currPageNum) - 1)" v-show="currPageNum > 1" min-width="20"
           style="background-color:rgba(81,81,81,1);margin-top:2px;height: 20px;line-height: 40px"
           class="px-0">
      <p style="font-size:10px;color: white;" class="iconfontFamily">&#xe617;</p>
    </v-btn>
    <p style="line-height:40px;" :style="{'margin-left' : currPageNum > 1 ? '10px' : '30px'}">{{ currPageNum }}/{{ totalPageNum }}</p>
    <v-btn @click="changePageNumber(parseInt(currPageNum) + 1)" v-show="currPageNum < totalPageNum" min-width="20"
           style="background-color:rgba(81,81,81,1);margin-top:2px;margin-left: 10px;height: 20px;line-height: 40px" class="px-0">
      <p style="font-size:10px;color: white;" class="iconfontFamily">&#xe61a;</p>
    </v-btn>
    <p style="line-height:40px;font-size: 14px" :style="{'margin-left' : currPageNum < totalPageNum ? '5px' : '35px'}"> ，转到</p>
    <div class="page-num-field mx-2">
      <v-text-field v-model="jumpToPageNum"
                    @keyup.enter.native="changePageNumber(jumpToPageNum)"
                    dense outlined
                    class="custom-height"
                    dark hide-details color="#ffffff">
      </v-text-field>
    </div>
    <p style="line-height:40px;font-size: 14px">页</p>

  </div>
</template>

<script>
export default {
  name: "MyFolderPageNumber",
  props: ["totalPageNum", "currPageNum"],
  data() {
    return {
      jumpToPageNum: "",
    }
  },
  computed: {
    jumpToPageNumList() {
      let arr = [];
      for (let i = 0; i < this.totalPageNum; i++) {
        arr.push(i + 1)
      }
      return arr;
    }
  },
  methods: {
    changePageNumber(number) {
      this.clearJumpNumber()
      if (isNaN(parseInt(number)) || number > this.totalPageNum || number < 0) {
        console.log('nan')
        return
      }
      this.$emit("changePageNumber", number)
    },
    clearJumpNumber() {
      this.jumpToPageNum = ''
    }
  }
}
</script>

<style scoped>
:deep(.v-input-control) {
  height: 10px;
}
.page-num-field {
  width: 48px;
}
.page-num-field :deep(.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot) {
  min-height: 24px;
}
</style>